import React, { Component } from 'react';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import {
  Container,
  Grid,
  Typography,
  Button,
  Divider,
  Stack,
  CircularProgress,
} from '@mui/material';
import _ from 'lodash';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import { connect } from 'react-redux';
import { Table, Breadcrumbs } from 'wae_rwlb_reactlibrary';

import {
  removeFavouriteItem,
  addToFavorite,
  clearFavorite,
  getFavouriteData,
  addRemoveFavourites,
  addMultipleItemToCart,
} from '../../../actions';
import { COLOR } from '../../../helpers/colors';
import { breadcrumbNameMap } from '../../../helpers/config';
import i18n from '../../../helpers/i18nMain';
import FavoritePlaceholder from '../FavoritePlaceholder';

const columnsConfig = (t, isFavourateIconLoading, selectedMaterial) => [
  {
    field: 'col1',
    headerName: t('favouriteScreenTranslations:PRODUCT'),
    key: 'Material',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'col2',
    headerName: t('favouriteScreenTranslations:DESCRIPTION'),
    key: 'MaterialName',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'col3',
    headerName: t('favouriteScreenTranslations:STOCK_QUANTITY'),
    key: 'StockQuantity',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'col4',
    headerName: '',
    key: 'SalesDocumentItem',
    sortable: false,
    minWidth: 150,
    flex: 1,
    renderCell: params => {
      return isFavourateIconLoading && params.row.col1 === selectedMaterial ? (
        <Stack direction="row" justifyContent="center" sx={{ flex: 1 }}>
          <CircularProgress size={20} />
        </Stack>
      ) : (
        <CloseOutlinedIcon
          color="error"
          sx={{ cursor: 'pointer', width: '100%' }}
          fontSize="inherit"
        />
      );
    },
  },
  {
    field: 'col5',
    headerName: t('favouriteScreenTranslations:SALES_PRICE'),
    key: 'SalesPrice',
    minWidth: 150,
    flex: 1,
    hide: true,
  },
];
class Favorite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      page: 0,
      rowsPerPage: 20,
      selectedMaterial: '',
    };
  }

  async componentDidMount() {
    try {
      await this.props.getFavouriteData(this.props.enqueueSnackbar);
    } catch (err) {
      console.log(err);
    }
  }

  remove = async i => {
    const { favourite, auth } = this.props;
    const { selectedSalesOrgData } = auth;
    const { ItemProp } = selectedSalesOrgData;

    const { favouriteItems } = favourite;
    const item = _.find(favouriteItems, o => o.Material === i.row.col1);

    try {
      const data = {
        NavMain: [
          {
            SalesDoucment: ItemProp,
            AddDelete: '2',
          },
        ],
        NavItems: [
          {
            Posnr: item.SalesDocumentItem,
          },
        ],
      };

      await this.props.addRemoveFavourites(data, this.props.enqueueSnackbar);
      this.loadFavorites();
    } catch (error) {
      console.log(error);
    }
  };

  removeAll = async () => {
    try {
      const { favourite, auth } = this.props;
      const { selectedSalesOrgData } = auth;
      const { ItemProp } = selectedSalesOrgData;
      const { favouriteItems } = favourite;

      const items = favouriteItems.map(f => ({ Posnr: f.SalesDocumentItem }));
      const data = {
        NavMain: [
          {
            SalesDoucment: ItemProp,
            AddDelete: '2',
          },
        ],
        NavItems: items,
      };

      await this.props.addRemoveFavourites(data, this.props.enqueueSnackbar);
      this.loadFavorites();
    } catch (error) {
      console.log(error);
      this.props.enqueueSnackbar('Failed', {
        variant: 'success',
      });
    }
  };

  loadFavorites = () => {
    try {
      this.props.getFavouriteData(this.props.enqueueSnackbar);
    } catch (error) {
      console.log(error);
    }
  };

  handleAddToCart = () => {
    let msg = '';

    try {
      const { favourite } = this.props;
      const { favouriteItems } = favourite;
      const { selectedRows } = this.state;
      const cartList = [];
      const selectedFavoriteList = [];

      selectedRows.forEach(g => {
        selectedFavoriteList.push(favouriteItems[g].Material);
      });

      selectedFavoriteList.forEach(sF => {
        const tD = favouriteItems.find(f => f.Material === sF && f.SalesPrice && f.StockQuantity);
        if (tD !== undefined) {
          const res = {
            Material: tD.Material,
            qty: parseInt(tD.ConditionQuantity, 10),
            MaterialName: tD.MaterialName,
            Price: tD.SalesPrice,
            Currency: tD.SalesPriceUnit,
            ConditionQuantity: tD.ConditionQuantity,
            MaterialGrossWeight: tD.MaterialGrossWeight,
            available: true,
            StockQuantityUOM: tD.StockQuantityUOM,
            StockQuantity: tD.StockQuantity,
            Tax: tD.Tax,
          };
          cartList.push(res);
          msg = i18n.t('productScreenTranslations:SUCC_ADDED_TO_THE_CART');
        } else {
          msg = i18n.t('productScreenTranslations:SOMETHING_WENT_WRONG');
        }
      });

      if (cartList.length > 0) {
        this.props.addMultipleItemToCart(cartList);
        this.props.enqueueSnackbar(msg, {
          variant: 'success',
        });
      }
      if (cartList.length === 0) {
        this.props.enqueueSnackbar(msg, {
          variant: 'error',
        });
      }
      this.setState({ selectedRows: [] });
    } catch (err) {
      this.props.enqueueSnackbar(msg, {
        variant: 'error',
      });
    }
  };

  renderFavourates = () => {
    const { favouriteItems, failText, isFavourateIconLoading } = this.props.favourite;
    const { rowsPerPage, selectedRows, page, selectedMaterial } = this.state;

    const { t } = this.props;
    const isNotEmpty = favouriteItems.length > 0;
    if (isNotEmpty) {
      return (
        <>
          <Stack direction="row" justifyContent="space-between">
            <Button
              variant="contained"
              color="primary"
              disabled={favouriteItems.length === 0 || selectedRows.length === 0}
              onClick={this.handleAddToCart}
              sx={{
                fontSize: { xs: 10, sm: 12, md: 14 },
                mb: 2,
              }}
            >
              {t('uploadScreenTranslations:ADD_TO_CART')}
            </Button>
            <Button
              color="error"
              variant="outlined"
              onClick={() => {
                this.removeAll();
              }}
              sx={{ mb: 2 }}
            >
              {t('favouriteScreenTranslations:CLEAR_FAVS')}
            </Button>
          </Stack>

          <Table
            checkboxSelection
            columnsConfig={columnsConfig(t, isFavourateIconLoading, selectedMaterial)}
            data={favouriteItems}
            onSelectionModelChange={s => {
              this.setState({ selectedRows: s });
            }}
            selectionModel={selectedRows}
            isRowSelectable={params => params.row.col3 > 0 && params.row.col5 > 0}
            handleOnCellClick={(params, event) => {
              event.stopPropagation();
              if (params.field === 'col4' && !isFavourateIconLoading) {
                this.setState({ selectedMaterial: params.row.col1 });
                this.remove(params);
              }
            }}
            onRowClick={() => {}}
            language={i18n.language}
            rowsPerPage={rowsPerPage}
            listCount={favouriteItems.length}
            page={page}
            // onPageChange={this.handleChange}
          />
          <Divider sx={{ mb: 2, mt: 2 }} />
        </>
      );
    }
    if (failText !== '') {
      return (
        <Typography sx={{ m: 4, fontSize: 36, color: COLOR.helperTextColor }} textAlign="center">
          {t('favouriteScreenTranslations:ERROR_MSG')}
        </Typography>
      );
    }
    return (
      <Grid container>
        <Grid item xs={12} textAlign="center">
          <Typography sx={{ fontSize: 32, color: COLOR.helperTextColor }}>
            {t('favouriteScreenTranslations:FAVS_EMPTY')}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  render() {
    const { t, favourite } = this.props;
    const { isLoading } = favourite;

    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <Grid sx={{ marginY: 6 }}>
          <ReactPlaceholder
            showLoadingAnimation
            ready={!isLoading}
            customPlaceholder={<FavoritePlaceholder />}
          >
            {this.renderFavourates()}
          </ReactPlaceholder>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    favourite: state.favourite,
    product: state.product,
    auth: state.auth,
  };
};
const cFavorite = connect(mapStateToProps, {
  removeFavouriteItem,
  addToFavorite,
  clearFavorite,
  getFavouriteData,
  addRemoveFavourites,
  addMultipleItemToCart,
})(Favorite);
const tFavorite = withTranslation(['favouriteScreenTranslations'])(cFavorite);
const sFavorite = withSnackbar(tFavorite);

export { sFavorite as Favorite };
